import api from './client';

// Standalone, fast hero-carousel fetch — independent of getAllHomeData's
// combined call so the hero (LCP element) never waits on unrelated
// below-the-fold sections. See src/pages/HomePage.js for how it's used.
export const getHomeBanners = async () => {
  try {
    const res = await api.get('/home/hero-banners');
    return res.data?.data || [];
  } catch (err) {
    console.error('Hero banners API error:', err);
    return [];
  }
};